/**
 * /ssl-certificate (easy-ssl) — migrated from public/js/easy-ssl.js.
 *
 * Plans slider custom cu arrow-left/right + swipe + responsive group size +
 * nav menu pentru schimbarea panel-ului activ (.plans.active).
 */
import { Resort } from '../core/resort.js';

new Resort(() => {
    let slidePos = 0;
    let slideWrapper: HTMLElement | null = null;
    let slideCard: NodeListOf<Element> = document.querySelectorAll('__never__');
    let slideGroup = 0;
    let colSize = 0;

    const plansWrapper = $('.plans-wrapper') as HTMLElement | null;
    if (!plansWrapper) return;
    const arrowLeft  = plansWrapper.findChildren('a.arrow-left')  as Element | null;
    const arrowRight = plansWrapper.findChildren('a.arrow-right') as Element | null;

    const slideMove = (): void => {
        if (slideWrapper) slideWrapper.style.transform = `translateX(-${colSize * slidePos}px)`;
        arrowLeft?.classList.toggle('disabled', !slidePos);
        arrowRight?.classList.toggle('disabled', slidePos === slideCard.length - slideGroup);
    };

    const setSlideGroup = (slideTarget: HTMLElement | null): void => {
        if (!slideTarget) return;
        slideWrapper = slideTarget.find('.slide-wrapper') as HTMLElement | null;
        slideCard    = slideTarget.find('.col', true) as NodeListOf<Element>;

        let sg = 1;
        const winSize = window.innerWidth;
        if (winSize >= 768) sg = 2;
        if (winSize >= 992) sg = 3;
        colSize = Math.ceil(slideTarget.clientWidth / sg);

        slideCard.forEach((node) => { (node as HTMLElement).style.width = `${colSize}px`; });
        arrowRight?.classList.toggle('disabled', slideCard.length === sg);

        slideGroup = sg;
        slidePos = 0;
        slideMove();
    };

    const slidePrev = (): void => { if (!slidePos) return; slidePos -= 1; slideMove(); };
    const slideNext = (): void => { if (slidePos === slideCard.length - slideGroup) return; slidePos += 1; slideMove(); };

    let tm: number | null = null;
    window.on('resize orientationchange', () => {
        if (tm !== null) { clearTimeout(tm); tm = null; }
        tm = window.setTimeout(() => setSlideGroup($('.plans.active') as HTMLElement | null), 300);
    });
    window.on('keydown', (e: Event) => {
        const ev = e as KeyboardEvent;
        if (ev.keyCode === 37) slidePrev();
        else if (ev.keyCode === 39) slideNext();
    });

    arrowLeft?.on('click', slidePrev);
    arrowRight?.on('click', slideNext);
    plansWrapper.on('swipeleft', slideNext);
    plansWrapper.on('swiperight', slidePrev);

    setSlideGroup($('.plans.active') as HTMLElement | null);

    /* Nav menu — switch between plan panels */
    let busy = false;
    ($('.nav-menu') as Element | null)?.on('click', 'a', function (this: Element) {
        if (busy) return;
        const navMenu = $('.nav-menu') as Element | null;
        if (!navMenu) return;
        const navChildren = navMenu.findChildren('a', true) as Element[];
        const index = this.index(navChildren as unknown as NodeListOf<Element>);
        busy = true;

        ($('.nav-menu a.active') as Element | null)?.classList.remove('active');
        this.classList.add('active');

        const activePlan = $('.plans.active') as HTMLElement | null;
        if (!activePlan) { busy = false; return; }
        activePlan.style.opacity = '0';
        activePlan.addEventListener('transitionend', function (this: HTMLElement) {
            this.classList.remove('active');
            this.style.display = 'none';

            const plan = ($('.plans', true) as NodeListOf<Element>).item(index) as HTMLElement;
            plan.style.display = 'flex';
            setSlideGroup(plan);

            setTimeout(() => {
                plan.style.opacity = '1';
                plan.addEventListener('transitionend', function (this: HTMLElement) {
                    this.classList.add('active');
                    busy = false;
                }, { once: true });
            });
        }, { once: true });
    });
});
